var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-data-table", {
    staticClass: "elevation-1",
    staticStyle: { width: "100%", "font-size": "12px" },
    attrs: { headers: _vm.headers, items: _vm.data, "hide-actions": "" },
    scopedSlots: _vm._u([
      {
        key: "items",
        fn: function (props) {
          return [
            _c("td", { staticClass: "text-xs-left" }, [
              _vm._v(_vm._s(props.item.id)),
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-xs-left" }, [
              _vm._v(_vm._s(props.item.lastUsed)),
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-xs-left" }, [
              _vm._v(_vm._s(props.item.count)),
            ]),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }